module.exports = __webpack_public_path__ + "img/select-btn_txt.eb1d41a6.png";